import { useQueryClient } from '@tanstack/react-query';
import useReactQueryBaseKey from 'hooks/react-query/useReactQueryBaseKey/useReactQueryBaseKey';

export const useJsaReportsInvalidQueryData = () => {
  const queryKey = [...useReactQueryBaseKey(), 'jsa-reports'];
  const client = useQueryClient();

  return () => client.invalidateQueries({ queryKey });
};
